import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';
import { bool, objectOf, string } from 'prop-types';

import FormWrapper from '~components/FormWrapper';
import LoadingWrapper from '~components/LoadingWrapper';
import SimulationActions from '~redux/Simulation/actions';
import { buildMainPath } from '~utils/path';
import { addPrefix } from '~utils/string';
import { FINANCIAL_INFO } from '~app/components/IncomesForm/constants';

import { getValidationSchema, mapInitialValues, postSocioeconomicInfoMapper } from './utils';
import styles from './styles.module.scss';
import SocioeconomicForm from './SocioeconomicForm';

const SocioeconomicInformation = ({ incumbent, nextStep, birthInfo, laborInfo, currentTarget, loading }) => {
  const [laborSituation, setLaborSituation] = useState(laborInfo?.employmentSituation);
  const dispatch = useDispatch();
  const { quickCode, kind } = useParams();

  const currentNextStepMeta = useSelector(
    state => state.simulation.currentSimulation?.requirements?.simulationNextStepMeta?.value
  );
  const currentWhenBuy = useSelector(state => state.simulation.whenBuy);

  const validationSchema = useMemo(() => getValidationSchema(laborSituation), [laborSituation]);
  const initialValues = useMemo(
    () => mapInitialValues({ birthInfo, laborInfo, whenBuy: currentWhenBuy }),
    [birthInfo, laborInfo, currentWhenBuy]
  );

  const handleSubmit = values => {
    dispatch(
      SimulationActions.setSimulationInfo(currentTarget, {
        ...birthInfo,
        gender: values.gender,
        birthday: values.birthday,
        nationality: values.nationality
      })
    );
    dispatch(
      SimulationActions.setSimulationInfo(addPrefix(incumbent, FINANCIAL_INFO), {
        employmentSituation: values.laborSituation,
        incomes: values.monthlyIncomes,
        emittedInvoicesLastYear: values.emittedInvoicesLastYear,
        jobStartDate: values.jobStartDate
      })
    );
    dispatch(SimulationActions.setSimulationInfo('whenBuy', values.whenBuy));
    dispatch(
      SimulationActions.changeIncumbent({
        quickCode,
        values: postSocioeconomicInfoMapper(values, incumbent, currentNextStepMeta),
        postSuccessAction: () => dispatch(push(buildMainPath(quickCode, nextStep, kind)))
      })
    );
  };

  return (
    <LoadingWrapper loading={loading}>
      <div className={styles.container}>
        <FormWrapper
          form={SocioeconomicForm}
          initialValues={initialValues}
          validationSchema={validationSchema}
          setLaborSituation={setLaborSituation}
          onSubmit={handleSubmit}
        />
      </div>
    </LoadingWrapper>
  );
};

SocioeconomicInformation.propTypes = {
  loading: bool.isRequired,
  birthInfo: objectOf(string),
  currentTarget: string,
  incumbent: string,
  laborInfo: objectOf(string),
  nextStep: string
};

export default SocioeconomicInformation;
